import { UgcAdCompositionScene, UgcAdCtaCard } from './types';
import { stableMediaUrl } from '../song-ad/stableMediaUrl';

export { default as UgcAdComposition } from './UgcAdComposition';
export type { UgcAdCompositionProps } from './UgcAdComposition';
export type { UgcAdCompositionScene, UgcAdCtaCard } from './types';
export { deriveUgcCompositionScenes, deriveUgcCtaCard, orderedIncludedScenes } from './deriveScenes';

// 尺配分・テロッププリセット・URL安定化は song-ad と共通実装（機能非依存の純関数群）。
// UGC側の呼び出しコードが song-ad ディレクトリへ直接依存しないよう、ここで再エクスポートする
export { computeSceneWindows, MIN_SCENE_SECONDS, computeCtaWindow } from '../song-ad/sceneTiming';
export {
  CAPTION_STYLE_CSS,
  CAPTION_STYLE_OPTIONS,
  CAPTION_POSITION_CSS,
  CAPTION_POSITION_OPTIONS,
  CAPTION_SIZE_RATIO,
  CAPTION_SIZE_OPTIONS,
  computeCaptionFontSize,
} from '../song-ad/captionPresets';
export { stableMediaUrl, invalidateStableMediaUrl } from '../song-ad/stableMediaUrl';

export const UGC_AD_FPS = 30;

/** 9:16 固定（1080×1920）。song-ad の getSongAdDimensions('9:16') と同じ値 */
export function getUgcAdDimensions(): { width: number; height: number } {
  return { width: 1080, height: 1920 };
}

export function getUgcAdDurationInFrames(targetSeconds: number): number {
  return Math.max(1, Math.round(targetSeconds * UGC_AD_FPS));
}

/**
 * EditorStep/PreviewStep 共通: deriveUgcCompositionScenes/deriveUgcCtaCard の出力と BGM URL へ
 * まとめてURL安定化を適用する（song-ad stabilizeCompositionMedia のUGC型版。理由は同ファイル参照）。
 */
export function stabilizeUgcCompositionMedia(
  scenes: UgcAdCompositionScene[],
  cta: UgcAdCtaCard | null,
  bgmUrl: string | null
): { scenes: UgcAdCompositionScene[]; cta: UgcAdCtaCard | null; bgmUrl: string | null } {
  return {
    scenes: scenes.map((scene) => ({
      ...scene,
      imageUrl: stableMediaUrl(scene.imageUrl),
      videoUrl: stableMediaUrl(scene.videoUrl),
    })),
    cta: cta
      ? {
          ...cta,
          backgroundImageUrl: stableMediaUrl(cta.backgroundImageUrl),
          logoUrl: stableMediaUrl(cta.logoUrl),
        }
      : null,
    bgmUrl: stableMediaUrl(bgmUrl),
  };
}
